// extracted by mini-css-extract-plugin
export var cardLayout = "_9r-1";
export var paginationContainer = "_9r-0";